module.exports = __webpack_public_path__ + "static/media/BulletList.b62e1e7d.svg";